import { isTestnet } from './config';

import aerodromLogo from 'assets/images/dex/aerodromLogo.jpg';
import aerodromLogoV2 from 'assets/images/dex/aerodromLogoV2.png';
import aerodromLogoWordMark from 'assets/images/dex/aerodromLogoWordMark.jpg';
import astradexLogo from 'assets/images/dex/astradexLogo.png';
import astradexLogoWordMark from 'assets/images/dex/astradexLogoWordMark.png';
import camelotLogo from 'assets/images/dex/camelotLogo.png';
import camelotLogoWordMark from 'assets/images/dex/camelotLogoWordMark.webp';
import jupiterLogo from 'assets/images/dex/jupiterLogo.png';
import jupiterLogoWordMark from 'assets/images/dex/jupiterLogoWordMark.png';
import pancakeLogoV2 from 'assets/images/dex/pancakeswapV2Logo.png';
import panckageV2LogoWordMark from 'assets/images/dex/pancakeswapV2LogoWordMark.png';
import pancakeLogoV3 from 'assets/images/dex/pancakeswapV3Logo.png';
import panckageV3LogoWordMark from 'assets/images/dex/pancakeswapV3LogoWordMark.png';
import quickswapLogo from 'assets/images/dex/quickswapLogo.svg';
import quickswapLogoWordMark from 'assets/images/dex/quickswapLogoWordMark.svg';
import raydiumLogo from 'assets/images/dex/raydiumLogo.svg';
import raydiumLogoWordMark from 'assets/images/dex/raydiumLogoWordMark.svg';
import sushiswapLogo from 'assets/images/dex/sushiswapLogo.svg';
import sushiswapLogoWordMark from 'assets/images/dex/sushiswapLogoWordMark.png';
import swopfiLogo from 'assets/images/dex/swopfiLogo.png';
import swopfiLogoWordMark from 'assets/images/dex/swopfiLogoWordMark.png';
import uniswapLogoV2 from 'assets/images/dex/uniswapLogoV2.svg';
import uniswapLogoV2WordMark from 'assets/images/dex/uniswapLogoV2WordMark.svg';
import uniswapLogoV3 from 'assets/images/dex/uniswapLogoV3.svg';
import uniswapLogoV3WordMark from 'assets/images/dex/uniswapLogoV3WordMark.svg';

export type IDexName =
  | 'uniswap_v2'
  | 'uniswap_v2:base'
  | 'uniswap_v2:robinhood'
  | 'uniswap_v3'
  | 'uniswap_v3:polygon'
  | 'uniswap_v3:arbitrum_one'
  | 'uniswap_v3:base'
  | 'uniswap_v3:robinhood'
  | 'pancakeswap_v2'
  | 'pancakeswap_v2:robinhood'
  | 'pancakeswap_v3:bsc'
  | 'pancakeswap_v3:robinhood'
  | 'pancakeswap_inf_cl:bsc'
  | 'quickswap_v2'
  | 'sushiswap_v2'
  | 'sushiswap_v3:haqq'
  | 'camelot_v2'
  | 'swopfi_v2:unit0'
  | 'astradex_v2:airdao'
  | 'aerodrome_v3:base'
  | 'aerodrome_v3_2:base'
  | 'aerodrome_v2_volatile:base'
  | 'jupiter:solana'
  | 'raydium';

interface IConfig {
  fee: number;
  icon: string;
  iconText: string;
}

export const dexConfigs: Record<IDexName, IConfig> = {
  uniswap_v3: {
    fee: 0.3,
    icon: uniswapLogoV3,
    iconText: uniswapLogoV3WordMark,
  },
  'uniswap_v3:arbitrum_one': {
    fee: 0.3,
    icon: uniswapLogoV3,
    iconText: uniswapLogoV3WordMark,
  },
  'uniswap_v3:polygon': {
    fee: 0.3,
    icon: uniswapLogoV3,
    iconText: uniswapLogoV3WordMark,
  },
  'uniswap_v3:base': {
    fee: 0.3,
    icon: uniswapLogoV3,
    iconText: uniswapLogoV3WordMark,
  },
  'uniswap_v3:robinhood': {
    fee: 0.3,
    icon: uniswapLogoV3,
    iconText: uniswapLogoV3WordMark,
  },
  uniswap_v2: {
    fee: 0.3,
    icon: uniswapLogoV2,
    iconText: uniswapLogoV2WordMark,
  },
  'uniswap_v2:base': {
    fee: 0.3,
    icon: uniswapLogoV2,
    iconText: uniswapLogoV2WordMark,
  },
  'uniswap_v2:robinhood': {
    fee: 0.3,
    icon: uniswapLogoV2,
    iconText: uniswapLogoV2WordMark,
  },
  pancakeswap_v2: {
    fee: isTestnet ? 0.2 : 0.25,
    icon: pancakeLogoV2,
    iconText: panckageV2LogoWordMark,
  },
  'pancakeswap_v2:robinhood': {
    fee: isTestnet ? 0.2 : 0.25,
    icon: pancakeLogoV2,
    iconText: panckageV2LogoWordMark,
  },
  'pancakeswap_v3:bsc': {
    fee: 0.3,
    icon: pancakeLogoV3,
    iconText: panckageV3LogoWordMark,
  },
  'pancakeswap_v3:robinhood': {
    fee: 0.3,
    icon: pancakeLogoV3,
    iconText: panckageV3LogoWordMark,
  },
  'pancakeswap_inf_cl:bsc': {
    fee: 0.67,
    icon: pancakeLogoV3,
    iconText: panckageV3LogoWordMark,
  },
  quickswap_v2: {
    fee: 0.3,
    icon: quickswapLogo,
    iconText: quickswapLogoWordMark,
  },
  sushiswap_v2: {
    fee: 0.3,
    icon: sushiswapLogo,
    iconText: sushiswapLogoWordMark,
  },
  'sushiswap_v3:haqq': {
    fee: 0.3,
    icon: sushiswapLogo,
    iconText: sushiswapLogoWordMark,
  },
  camelot_v2: {
    fee: 0.3,
    icon: camelotLogo,
    iconText: camelotLogoWordMark,
  },
  'swopfi_v2:unit0': {
    fee: 0.3,
    icon: swopfiLogo,
    iconText: swopfiLogoWordMark,
  },
  'astradex_v2:airdao': {
    fee: 0.3,
    icon: astradexLogo,
    iconText: astradexLogoWordMark,
  },
  'aerodrome_v3:base': {
    fee: 0.3,
    icon: aerodromLogo,
    iconText: aerodromLogoWordMark,
  },
  'aerodrome_v3_2:base': {
    fee: 0.3,
    icon: aerodromLogo,
    iconText: aerodromLogoWordMark,
  },
  'aerodrome_v2_volatile:base': {
    fee: 0.3,
    icon: aerodromLogoV2,
    iconText: aerodromLogoWordMark,
  },
  'jupiter:solana': {
    fee: 0.3,
    icon: jupiterLogo,
    iconText: jupiterLogoWordMark,
  },
  raydium: {
    fee: 0.3,
    icon: raydiumLogo,
    iconText: raydiumLogoWordMark,
  },
};
